export default __webpack_public_path__ + "static/media/TermsOfUse-NL.6a5482c7.pdf";